import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import EditExchangeDeliveryInfoModal from '../../../../views/order/common/modal/EditExchangeDeliveryInfoModal';
import { orderActions } from '../../../../store/modules/order';
import { ORDER_DELIVERY_TYPE } from '../../../../constants/service/app/orderConstants';
import { setTrim } from '../../../../lib/common';
import withModal from '../../../../lib/hoc/withModal';

class EditExchangeDeliveryInfoModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  택배 방법
       */
      exchangeDeliveryType: ORDER_DELIVERY_TYPE.PARCEL_DELIVERY,
      /**
       *  택배사
       */
      exchangeDeliveryAgentId: null,
      /**
       *  송장번호
       */
      exchangeInvoiceNumber: null,
    };
  }

  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;

    toggleModal({
      name: 'editExchangeDeliveryInfoModal',
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 재배송 송장 수정하기
   */
  onSubmit = () => {
    const { form, data, editOrderExchangeDeliveryInfo } = this.props;
    const { exchangeDeliveryType, exchangeDeliveryAgentId, exchangeInvoiceNumber } = this.state;
    const { orderItemList } = data;

    form.validateFields((err) => {
      if (err) return;

      editOrderExchangeDeliveryInfo({
        orderItemIdList: orderItemList.map((item) => item.orderItemId),
        deliveryType: exchangeDeliveryType,
        deliveryAgentId: exchangeDeliveryAgentId,
        invoiceNumber: setTrim(exchangeInvoiceNumber),
      });

      this.closeModal();
    });
  };

  render() {
    const { form, isOpen, data } = this.props;

    return (
      <EditExchangeDeliveryInfoModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        setData={this.setData}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.editExchangeDeliveryInfoModal.isOpen,
    data: state.order.editExchangeDeliveryInfoModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  editOrderExchangeDeliveryInfo: orderActions.editOrderExchangeDeliveryInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(EditExchangeDeliveryInfoModalContainer)));
